import { TargetIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { useState } from 'react'

export const ToggleMeasurementPrecision: React.FC = () => {
  const { sendCommand } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()

  const [measurementPrecision, setMeasurementPrecision] = useState(3) // Default precision is 3 decimal places

  return (
    <TooltipWrapper
      side={'top'}
      offset={5}
      label={`Toggle Measurement Precision: ${measurementPrecision === 0 ? '1' : `0.${'0'.repeat(measurementPrecision - 1)}1`}`}>
      <ViewToggle
        onClick={() => {
          const newPrecision = (measurementPrecision + 1) % 7
          setMeasurementPrecision(newPrecision)
          sendCommand({
            command: 'setMeasurementPrecision',
            precision: newPrecision,
          })
          trackButtonClicked({
            button_name: 'kestrel_toggle_measurement_precision',
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          })
        }}>
        <TargetIcon style={{ color: 'white' }} width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
